module.exports = __webpack_public_path__ + "static/shivaani-318d2eddd34702c8cdd9b3e8e6727c56.jpeg";